export function cookies(): Record<string, string> {
  const cookieObj: Map<string, string> = new Map();

  const cookies = document.cookie.split('; ');
  for (const cookie of cookies) {
    const parts = cookie.split('=');
    const name = decodeURIComponent(parts[0]);
    const value =
      parts.length > 1 ? decodeURIComponent(parts.slice(1).join('=')) : '';
    cookieObj.set(name, value);
  }

  return Object.fromEntries(cookieObj);
}
